export const pickOfficeBranding = (offices, userOffices) => {
  const active = (offices || []).filter((office) => office.status !== 'disabled');
  if (userOffices?.length === 1) {
    const id = userOffices[0].client_office_id || userOffices[0].id;
    const name = userOffices[0].office_name;
    return (
      active.find(
        (office) =>
          office.client_office_id === id ||
          office.id === id ||
          office.office_name === name
      ) ||
      active[0] ||
      {}
    );
  }
  if (active.length > 1) {
    return active.find((office) => office.is_primary) || active[0] || {};
  }
  return active[0] || {};
};

export const replaceMessagingVars = (text, vars = {}) => {
  if (!text) return '';
  return String(text).replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_, key) =>
    vars[key] != null ? String(vars[key]) : ''
  );
};

export const splitTextBlocks = (text) =>
  String(text || '')
    .split(/\n+/)
    .map((line) => line.trim())
    .filter(Boolean);
